import { render, staticRenderFns } from "./rule5.vue?vue&type=template&id=b4b94ef2&scoped=true"
import script from "./rule5.vue?vue&type=script&lang=js"
export * from "./rule5.vue?vue&type=script&lang=js"
import style0 from "./rule5.vue?vue&type=style&index=0&id=b4b94ef2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4b94ef2",
  null
  
)

export default component.exports